import { render, staticRenderFns } from "./TechnicalNotes.vue?vue&type=template&id=e64eccd4"
import script from "./TechnicalNotes.vue?vue&type=script&lang=js"
export * from "./TechnicalNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports